import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 60000,
});

// Always attach Bearer token from localStorage as fallback (in case cookies fail in iframe contexts)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vedari_session_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  // Send current UI language so backend LLM calls reflect user's preference immediately,
  // without waiting for /me/preferences PUT to land in DB.
  const lang = localStorage.getItem("vedari_lang");
  if (lang) {
    config.headers = config.headers || {};
    config.headers["X-Lang"] = lang;
  }
  return config;
});

// Friendly error handling — surface 429/5xx with a contemplative toast (suppress on 401/403/404
// which are handled by individual pages, and on PDF blob endpoints).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    const isBlob = err?.config?.responseType === "blob";
    if (isBlob) return Promise.reject(err);
    const status = err?.response?.status;
    const isHi = localStorage.getItem("vedari_lang") === "hi";
    if (status === 429) {
      toast.message(isHi ? "क्षण रुकें — कुछ ही क्षण में पुनः प्रयास करें।" : "A small pause — try again in a moment.");
    } else if (status >= 500 && status < 600) {
      toast.error(isHi ? "एक मूक त्रुटि। पुनः प्रयास करें।" : "A quiet error. Please try again.");
    } else if (!err?.response && err?.code !== "ERR_CANCELED" && !url.includes("/auth/me")) {
      toast.message(isHi ? "नेटवर्क बहुत धीमा है।" : "The network feels slow.");
    }
    return Promise.reject(err);
  },
);

export default api;
